import React, {Component, PropTypes} from 'react';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';

class RequiredIndicator extends Component {
  render() {
    const { isRequired, css } = this.props;

    if(isRequired)
      return <span className={css.requiredIndicator}> *</span>;
    else
      return null;
  }
}

RequiredIndicator.propTypes = {
  isRequired: PropTypes.bool.isRequired
};

export default styleable(defaultStyle) (RequiredIndicator);



// WEBPACK FOOTER //
// src/common/required-indicator.js